import React from 'react';
import SEO from '../components/SEO';
import HeroSection from '../components/HeroSection';
import FlavorsSection from '../components/FlavorsSection';
import FeaturesSection from '../components/FeaturesSection';
import VideoSection from '../components/VideoSection';
import InstagramSection from '../components/InstagramSection';
import NewsletterSection from '../components/NewsletterSection';

const HomePage = () => {
  return (
    <main>
      <SEO
        title="Băutura Răcoritoare cu Alcool Premium"
        url="https://seltz.eu"
        description="Seltz - Băutura premium cu vodcă și arome de fructe naturale. Cel mai bun hard seltzer din România. 0 zahăr, fără gluten."
      />
      <HeroSection />
      <FlavorsSection />
      <FeaturesSection />
      <VideoSection />
      <InstagramSection />
      <NewsletterSection />
    </main>
  );
};

export default HomePage;
